// extracted by mini-css-extract-plugin
module.exports = {"titles":"SocialShareModal-module__titles___114Kf","subtitles":"SocialShareModal-module__subtitles___2G8uZ","ctas":"SocialShareModal-module__ctas___-3srF"};